<template>
  <v-dialog v-model="dialog" width="90%" scrollable persistent>
    <v-card>
      <v-card-title class="pa-1">
        <v-col cols="12" class="pa-0 text-right">
          <v-btn icon color="primary" @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="pa-0 text-center">
          <h1>Acompanhamento de Envio de Recursos</h1>
          <p>Recurso de Glosas - acompanhamento de envio {{info.envio_manual? ' manual':' automatico'}}</p>
        </v-col>
        <v-row class="mx-4 my-2 pa-3" style="background-color: #d1dcea">
          <v-col cols="2" class="pa-0 ma-0">
            <div class="px-0 pt-0 text-list">
              <b>{{ info.oper_nome }}</b
              ><br>
              {{ info.prest_nome }}
            </div>
          </v-col>
          <v-col cols="10" class="pa-0">
            <v-row class="ma-0">
              <v-col class="text-list text-right px-0 py-0"
                ><small>Data pagamento:</small><br /><b>{{
                  info.data_pagamento | formatDate
                }}</b></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.informado(R$):</small><br /><b>{{
                  info.valor_informado | formatPrice
                }}</b></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.liberado(R$):</small><br /><b
                  ><span style="color: #32b88b">{{
                    info.valor_liberado | formatPrice
                  }}</span></b
                ></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.glosado(R$):</small><br /><b
                  ><span style="color: red">{{
                    info.valor_glosado | formatPrice
                  }}</span></b
                >
              </v-col>
              <v-col class="text-list text-right px-0 py-0"
                ><small>Glosa mantida(R$):</small><br /><span
                  style="color: red"
                  >{{ info.valor_glosa_mantida | formatPrice }}</span
                ></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.recursado(R$):</small><br /><span
                  style="color: #32b88b"
                  >{{ info.valor_recursado | formatPrice }}</span
                ></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.acatado(R$):</small><br /><span
                  style="color: #118aca"
                  >{{ info.valor_acatado | formatPrice }}</span
                ></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="py-2">
        <v-row>
          <span class="px-3 pt-2" v-if="protocolo_pagamento && protocolo_pagamento.data_envio">Recurso enviado em <b style="font-size: 1.2em">{{protocolo_pagamento.data_envio | formatDate}}.</b></span><span class="px-2 pt-2" v-if="protocolo_pagamento && protocolo_pagamento.protocolo_envio"> Protocolo nº <b style="font-size: 1.2em">{{protocolo_pagamento.protocolo_envio}}</b></span>
          <!-- <v-col class="px-3 py-0" cols="12" sm="6" md="4" lg="4">
            <v-text-field
              v-model="busca"
              small
              height="30px"
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar"
              single-line
              outlined
              dense
              hide-details
              @keyup="filterList(busca)"
            ></v-text-field>
          </v-col> -->
          <!-- <v-col cols="2" class="pl-8 pr-0">
            <v-btn
              color="primary"
              height="30px"
              small
              depressed
              @click="filterList(busca)"
              >Filtrar
            </v-btn>
          </v-col> -->
          <!-- <v-col cols="6" class="text-right px-8 pr-0"> -->
          <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showProtocoloEnvioRecursoDlg=true" v-if="info.envio_manual && tipo_protocolo!='lote'">
                <v-icon small class="pr-2">fa-pencil-alt</v-icon>
                Protocolo único
            </v-btn>
            <!-- <v-btn color="primary" text @click="downloadRecurso('xml', info)">
              <v-icon small class="pr-2">fa fa-download</v-icon>
              Arquivo gerado
            </v-btn> -->
            <v-btn color="primary" text @click="downloadDocument()">
                <v-icon small class="pr-2">fa-download</v-icon>
                Exportar tabela
            </v-btn>
          <!-- </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" class="py-1 px-3">
            <v-form ref="addProtocoloLotesRecursadosForm">
            <v-data-table
              :class="[info.envio_manual && !protocolo_pagamento?'envio_manual': '', 'lotesRecursoTable']"
              dense
              :headers="headers"
              :items="list"
              hide-default-footer
            >
            <template v-slot:item.valor_recursado="{ item }">
              <b style="color:#32B88B"  v-if="item.valor_recursado">{{ item.valor_recursado | formatPrice }}</b>
            </template>
            <template v-slot:item.valor_acatado="{ item }">
              <b style="color:red"  v-if="item.valor_acatado">{{ item.valor_acatado | formatPrice }}</b>
            </template>
            <template v-slot:item.protocolo_envio="{ item }">
              <b  v-if="!info.envio_manual || tipo_protocolo=='pagamento' || item.valor_recursado <= 0">{{item.protocolo_envio}}</b>
              <v-text-field 
                v-else
                dense
                type="text"
                v-model="item.protocolo_envio"
                flat
                :rules="[formRules.max20]"
                @input="exibirSalvar=true"
                class="mb-n5 input-no-border"
                >
              </v-text-field>
            </template>
             <template v-slot:item.data_envio="{ item }" >
              <b v-if="!info.envio_manual || tipo_protocolo=='pagamento' || item.valor_recursado <= 0">{{item.dataEnvio=formatDate(item.data_envio)}}</b>
              <v-menu 
                  v-else
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  width="120"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="item.dataEnvio"
                    format="DD/MM/YYYY"
                    v-mask="'##/##/####'"
                    dense
                    flat
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @blur="item.data_envio = parseDate(item.dataEnvio)"
                    class="mb-n5 input-no-border"
                    :rules="[formRules.typeDateFormated]"
                  ></v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="item.data_envio"
                    no-title
                    @input="item.dataEnvio = formatDate(item.data_envio); exibirSalvar=true"
                    >
                  </v-date-picker>
                </v-menu>
            </template>
             <template v-slot:item.data_atualizacao="{ item }">
              <b>{{ item.data_atualizacao | formatDate }}</b>
            </template>
            <template v-slot:item.status="{ item }">
              <b>{{ item.status }}</b>
              <v-tooltip bottom open-delay="100" v-if="!!item.erros">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                    class="mr-2 mt-2" 
                    color="error" 
                    small
                    v-bind="attrs" 
                    v-on="on">fa-warning
                  </v-icon>
                </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">{{item.erros}}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.docs="{ item }">
              <v-tooltip bottom open-delay="100" v-if="!!item.doc_id_recurso">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        class="mr-2 mt-2" 
                        color="primary" 
                        small
                        v-bind="attrs" 
                        v-on="on"
                        @click="download({doc_id: item.doc_id_recurso})"
                      >fa-file-code
                      </v-icon>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                      >Arquivo gerado</span
                    >
                  </v-tooltip>
                  <v-tooltip bottom open-delay="100" v-if="!!item.doc_id_protocolo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      class="mr-2 mt-2" 
                      color="primary" 
                      small
                      v-bind="attrs" 
                      v-on="on"
                      @click="download({doc_id: item.doc_id_protocolo})"
                    >fa-file-contract 
                    </v-icon>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                    >Protocolo de envio</span
                  >
                  </v-tooltip>
                  <v-tooltip bottom open-delay="100" v-if="!!item.doc_id_situacao">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      class="mr-0 mt-2" 
                      color="primary" 
                      small
                      v-bind="attrs" 
                      v-on="on"
                      @click="download({doc_id: item.doc_id_situacao})"
                    >fa-file-invoice
                    </v-icon>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                    >Situação de protocolo</span
                  >
                  </v-tooltip>
                   <!-- v-if="!!item.doc_id_protocolo" -->
                   <!-- <v-tooltip bottom open-delay="100">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      class="mr-3 mt-2" 
                      color="warning" 
                      small
                      v-bind="attrs" 
                      v-on="on"
                    >fa-people-carry
                    </v-icon>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                    >Envio manual. É necessário anexo.</span
                  >
                  </v-tooltip> -->

                  
            </template>
            </v-data-table>
            </v-form>
          </v-col>
          <v-col cols="12" class="py-1">
            <v-pagination
              class="no-box-shadow"
              v-model="pagination.current_page"
              :length="pagination.total_pages"
              @input="pagination.offset = pagination.current_page; filterList()"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="justify-center py-5">
        <v-btn color="primary" outlined height="30px" small depressed @click="close()"
          >Fechar
        </v-btn>
        <v-btn color="primary" height="30px" small depressed v-show="exibirSalvar" @click="saveProtocolos()"
          > Salvar protocolos
        </v-btn>
      </v-card-actions>
    </v-card>
    <ProtocoloEnvioRecursoDlg
      :close="()=>showProtocoloEnvioRecursoDlg=false"
      :dialog="showProtocoloEnvioRecursoDlg"
      :grupoEconomico="grupoEconomico"
      :info="info"
      :protocolo_pagamento="protocolo_pagamento"
      :updatePage="()=>filterList()"
    />
  </v-dialog>
</template>

<script>
import ProtocoloEnvioRecursoDlg from "./ProtocoloDlg"
import { mapState } from "vuex"
export default {
  components: {
    ProtocoloEnvioRecursoDlg
  },
  data() {
    return {
      exibirSalvar: false,
      headers: [
        { text: "Protocolo recursado", value: "protocolo_recursado", sortable: false },
        { text: "Nº do Lote", value: "numero_lote", sortable: false },
        { text: "N da Guia do Recurso", value: "numero_guia_recurso", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Protocolo envio", value: "protocolo_envio", sortable: false },
        { text: "Data envio", value: "data_envio", sortable: false },
        { text: "Mensagens", value: "mensagens", sortable: false },
        { text: "Vl. Recursado", value: "valor_recursado", sortable: false },
        { text: "Vl. Acatado", value: "valor_acatado", sortable: false },
        { text: "Data atualização", value: "data_atualizacao", sortable: false },
        { text: "Documentos", value: "docs", sortable: false },
      ],
      list: [],
      pagination: {
        current_page: 1,
        limit: 5,
        offset: 1,
        total_pages: 1
      },
      protocolo_pagamento: null,
      tipo_protocolo: null,
      showProtocoloEnvioRecursoDlg:false
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
  },  
  watch:{
    dialog(val){
      if(val){
        this.exibirSalvar = false
        this.filterList() 
      } else {
        this.pagination.offset=1
        this.pagination.current_page=1
        this.pagination.total_pages=1
        this.list=[]
        this.protocolo_pagamento=null
      }
    }
  },
  props: {
    close: Function,
    dialog: Boolean,
    downloadRecurso: Function,
    getList: Function,
    grupoEconomico: Number,
    info: Object,
  },
  methods: {
    filterList() {
      let {limit, offset} = this.pagination
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "getlotesrecursados",
            payload: {
              grupo_economico: this.grupoEconomico,
              pagamento_id: this.info.id,
              limit,
              offset 
            },
          },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          let {dados, data_envio, protocolo_envio, total_pages, current_page, tipo_protocolo } = response
          this.list = dados.map(item => { 
            item.dataEnvio = this.formatDate(item.data_envio) 
            return item})
          this.protocolo_pagamento = (!!data_envio || !!protocolo_envio)? { data_envio, protocolo_envio} : null
          this.tipo_protocolo = tipo_protocolo
          this.pagination.total_pages = total_pages
          this.pagination.current_page = current_page
        })
    },
      download(docData){
      let Payload = {
        grupo_economico: this.grupoEconomico,
        pagamento_id: this.info.id,
        ...docData
      };
      this.$store
        .dispatch(
          "documents/getDocument",
          Payload ,
          { root: true }
        )
    },
    downloadDocument() {
      let acao = "getcsvlotesrecursados";
      let Payload = {
        grupo_economico: this.grupoEconomico,
        pagamento_id: this.info.id,
      };
      this.$store
        .dispatch(
          "documents/getDocumentPost",
          { Payload, acao },
          { root: true }
        ).then(()=> {
          alert()
        })
    },
    formatDate (date) {
        if (!date) return null
        
        const [year, month, day] = date.split("T")[0].split('-')
        return `${day}/${month}/${year}`
    },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    saveProtocolos() {
      if(!this.$refs.addProtocoloLotesRecursadosForm.validate()){
alert('invalidForm')
return
      }
        let {prestador_id, operadora_ans_id, data_pagamento, id} = this.info
        let protocolos = this.list.map(el => ({lote_id: el.id, protocolo_envio: el.protocolo_envio, data_envio: el.data_envio }))
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "AddProtocoloLotesRecursados",
              payload: {
                grupo_economico: this.grupoEconomico,
                protocolos,
                pagamento_id: id,
                prestador_id, 
                operadora_ans_id, 
                data_pagamento
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            let paramModal = {
                type: "success",
                title: "Sucesso",
                message: response.mensagem,
                callback: ()=> {this.exibirSalvar = false; this.filterList(); },
                btConfirm: { name: "Ok", show: true },
                btCancel: { name: "Não", show: false },
              };
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });
    },
  },
};
</script>

<style lang="scss">
.text-list {
  font-size: 13px;
  line-height: 1.15em;
}
.text-list.space {
  margin-right: 3px;
}
.text-list.pres {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lotesRecursoTable.envio_manual {
  .v-data-table__wrapper > table > tbody > tr td:nth-child(5), 
  .v-data-table__wrapper > table > tbody > tr td:nth-child(6) {
    background-color: rgba(207, 212, 3, .10) !important;
  }
}
.lotesRecursoTable {
  .v-data-table__wrapper > table > tbody > tr td:nth-child(6){
    max-width: 150px;
  }
}
</style>